interface Props {
  open: boolean;
  onClose: () => void;
}

const GROUPS: Array<{ heading: string; items: Array<[string, string]> }> = [
  {
    heading: 'Navigate',
    items: [
      ['j / k', 'Next / previous task'],
      ['Enter', 'Open task'],
      ['Esc', 'Close detail / cancel'],
    ],
  },
  {
    heading: 'Act',
    items: [
      ['Space', 'Complete (10s undo)'],
      ['p', 'Pin / unpin'],
      ['s', 'Snooze 1 day'],
      ['n', 'Add note (→ Pending)'],
    ],
  },
  {
    heading: 'Prioritize',
    items: [['1 / 2 / 3', 'Priority: low / med / high']],
  },
  {
    heading: 'Move',
    items: [
      ['m then p', 'Move to Personal'],
      ['m then w', 'Move to Woxom Health'],
      ['m then l', 'Move to LeadMomentum'],
      ['m then c', 'Move to Client Link'],
    ],
  },
  {
    heading: 'Help',
    items: [['?', 'Show / hide this panel']],
  },
];

export function CommandBar({ open, onClose }: Props) {
  if (!open) return null;
  return (
    <div
      className="command-bar-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Keyboard shortcuts"
      onClick={onClose}
    >
      <div className="command-bar" onClick={(e) => e.stopPropagation()}>
        <header>
          <h3>Keyboard shortcuts</h3>
          <button onClick={onClose} aria-label="Close">×</button>
        </header>
        {GROUPS.map((group) => (
          <section key={group.heading} className="shortcut-group">
            <h4>{group.heading}</h4>
            <dl className="shortcut-list">
              {group.items.map(([keys, desc]) => (
                <div key={keys} className="shortcut-row">
                  <dt><kbd>{keys}</kbd></dt>
                  <dd>{desc}</dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>
    </div>
  );
}
